// extracted by mini-css-extract-plugin
export default {"inputStyle":"input_inputStyle__9tOET"};